// Попап для вывода ошибок

import basePopup from "./base-popup";

const template = /* html */`
    <transition name="fade">
        <base-popup id="error-popup" class="error-popup" small-popup v-cloak v-show="isActive">
            <h2 class="error-popup__title">
                <i class="fa fa-2x fa-exclamation-circle"></i> <span>Ошибка</span>
            </h2>
            <div class="error-popup__text js-popup-content popup__content">
                <p v-for="error in errors" :key="error" v-html="error"></p>
            </div>
        </base-popup>
    </transition>
`;

export default {
    template,
    props: {
        errors: {
            type: Array,
            required: true,
        },
        isActive: { type: Boolean },
    },
    components: { basePopup },
};
